import { type CSSProperties, type FC, type ReactNode } from 'react';
import { LazyLoadComponent } from 'react-lazy-load-image-component';

interface OptimizedBackgroundImageProps {
  src: string;
  className?: string;
  style?: CSSProperties;
  threshold?: number;
  children?: ReactNode;
  placeholderColor?: string;
}

/**
 * Composant d'image de fond optimisé avec chargement lazy
 * Utilise react-lazy-load-image-component pour les background images
 */
export const OptimizedBackgroundImage: FC<OptimizedBackgroundImageProps> = ({
  src,
  className,
  style,
  threshold = 100,
  children,
}) => (
  <LazyLoadComponent threshold={threshold}>
    <div
      className={className}
      style={{
        backgroundImage: `url(${src})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        ...style,
      }}
    >
      {children}
    </div>
  </LazyLoadComponent>
);
